// extracted by mini-css-extract-plugin
export var blue = "_20-f";
export var brand = "_20-b";
export var darkGrey = "_20-e";
export var disabled = "_20-4";
export var disabledSubtle = "_20-5";
export var error = "_20-6";
export var green = "_20-g";
export var grey = "_20-d";
export var icon = "_20-0";
export var inherit = "_20-a";
export var lightGrey = "_20-c";
export var orange = "_20-i";
export var pink = "_20-k";
export var primary = "_20-1";
export var purple = "_20-l";
export var red = "_20-j";
export var secondary = "_20-2";
export var success = "_20-9";
export var tertiary = "_20-3";
export var warning = "_20-7";
export var warningSecondary = "_20-8";
export var white = "_20-m";
export var yellow = "_20-h";